/**
 * External dependencies
 */
import { get } from 'lodash';

export default (name) => (state) => get(state, ['ui', 'modal', name, 'isVisible'], false);
